export const stringsByLocale = {
  en: [
    "What it is",
    "Fear origins",
    "Anxiety symptoms",
    "Differential diagnoses",
    "What to watch and why",
    "Diagnostics",
    "Treatment",
    "Patient monitoring",
    "Prevention",
    "Prognosis",
    "Stories",
    "About us"
  ],
  cs: [
    "Co je separační úzkost",
    "Jak vzniká strach",
    "Projevy úzkosti",
    "Diferenciální diagnózy",
    "Co sledovat a proč",
    "Diagnostika",
    "Léčba",
    "Monitorování pacienta",
    "Prevence",
    "Prognóza",
    "Příběhy",
    "O nás"
  ]
} as { [key: string]: string[] };
